"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Keeps a reference to the source specs and a count of the targets.
 * This allows the source specs to be retrieved and invoke functions on them at a later time.
 */
var ElementConnectionsRegistry = function ElementConnectionsRegistry() {
    var _this = this;

    _classCallCheck(this, ElementConnectionsRegistry);

    this.addSource = function (id, sourceSpec) {
        _this.sources[id] = sourceSpec;
    };

    this.removeSource = function (id) {
        _this.sources[id] = null;
    };

    this.getSource = function (id) {
        return _this.sources[id];
    };

    this.sources = {};
};

exports.default = ElementConnectionsRegistry;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/ElementConnectionsRegistry.js
// module id = 1704
// module chunks = 0